import './../css/App.css';
import React, { Component } from 'react';
import InfoTile from './../js/InfoTile'

class Press extends Component {
  render() {
    return (
      <div className="press">
        <div className="header">PRESS</div>
          <InfoTile href="https://www.ny1.com/nyc/all-boroughs/news/2019/03/25/how-a-foodie-family-of-four-became-instagram-famous"
            title="NY1"
            date="Mar 25, 2019"
            description="How a Foodie Family of Five Became Instagram Famous"
            imagePath="http://foodbabyny.com/press/press_20190325_ny1.jpg"
          ></InfoTile>
          <InfoTile href="https://people.com/parents/how-i-parent-blogger-mom-of-3-near-family/"
            title="People"
            date="Mar 1, 2019"
            description="How I Parent: A Blogger Mom of 3 Whose Parents Help Out"
            imagePath="http://foodbabyny.com/press/press_20190301_people.jpg"
          ></InfoTile>
          <InfoTile href="https://www.newyorker.com/magazine/2019/01/07/the-food-babies-of-instagram"
            title="The New Yorker"
            date="Jan 7, 2019"
            description="The Food Babies of Instagram"
            imagePath="http://foodbabyny.com/press/press_20190107_newyorker.jpg"
          ></InfoTile>
          <InfoTile href="https://hesterstreetfair.com/events/hester-street-fair-foodbabyny-food-fest/"
            title="Hester Street Fair"
            date="Oct 21, 2018"
            description="The FoodBabyNY Food Fest @ Hester Street Fair"
            imagePath="http://foodbabyny.com/press/press_20181021_hesterstreetfair.jpg"
          ></InfoTile>
          <InfoTile href="http://www.thhsclassic.com/2018/10/11/meet-townsend-harris-insta-famous-food-bloogers-mike-and-alexandra-chau-class-of-2001/"
            title="The THHS Classic"
            date="Oct 11, 2018"
            description="Meet Townsend Harris’ Insta-Famous Food Bloggers"
            imagePath="http://foodbabyny.com/press/press_20181011_thhs.jpg"
          ></InfoTile>
          <InfoTile href="https://www.rachaelrayshow.com/articles/these-insta-famous-food-critics-are-3-and-5-years-old"
            title="Rachael Ray Show"
            date="Oct 2, 2018"
            description="These Insta-Famous Food Critics Are 3 And 5 Years Old!"
            imagePath="http://foodbabyny.com/press/press_20181002_rachaelray.jpg"
          ></InfoTile>
          <InfoTile href="http://www.grubstreet.com/2018/08/best-places-to-take-kids-out-to-eat.html"
            title="Grub Street"
            date="Aug 20, 2018"
            description="The Best Places to Take a Kid, According to a 5-Year-Old"
            imagePath="http://foodbabyny.com/press/press_20180820_grubstreet.jpg"
          ></InfoTile>
          <InfoTile href="https://www.facebook.com/NowThisFood/videos/945201515659901/"
            title="NowThis News"
            date="May 9, 2018"
            description="This Instagram Combines Food and Babies"
            imagePath="http://foodbabyny.com/press/press_20180509_nowthisnews.jpg"
          ></InfoTile>
          <InfoTile href="http://www.newyorkfamily.com/cute-babies-of-instagram/"
            title="New York Family"
            date="Apr 23, 2018"
            description="Cute Babies Of Instagram"
            imagePath="http://foodbabyny.com/press/press_20180423_newyorkfamily.jpg"
          ></InfoTile>
          <InfoTile href="http://shortyawards.com/10th/foodbabyny"
            title="Shorty Awards"
            date="Apr 15, 2018"
            description="FoodBabyNY nominated at 10th Annual Shorty Awards"
            imagePath="http://foodbabyny.com/press/press_20180415_shortyawards.jpg"
          ></InfoTile>
          <InfoTile href="http://www.fhm.com/posts/instagram-foodie-food-baby-ny-156397"
            title="FHM"
            date="Mar 20, 2018"
            description="Meet Mike Chau, A Dad Who Turned His Love Of Food And Family Into Instagram Gold"
            imagePath="http://foodbabyny.com/press/press_20180320_fhm.jpg"
          ></InfoTile>
          <InfoTile href="https://explorestlouis.com/foodbabyny-explores-st-louis-dining-scene/"
            title="Explore St. Louis"
            date="Jan 3, 2018"
            description="FoodbabyNY Explores St. Louis’ Dining Scene"
            imagePath="http://foodbabyny.com/press/press_20180103_explorestlouis.jpg"
          ></InfoTile>
          <InfoTile href="https://www.facebook.com/PureWow/videos/1927400077275029/?hc_ref=ARQXSsmYxgtX3UT_m3Tbe8YcWYPIy7s8dknhQfVmgxNHRPU6bs0ZFbX1FOAFKOYuTpo"
            title="PureWow"
            date="Dec 11, 2017"
            description="Have you ever seen a cuter Instagram?"
            imagePath="http://foodbabyny.com/press/press_20171211_purewow.jpg"
          ></InfoTile>
          <InfoTile href="http://abc7ny.com/food/these-cute-kids-eat-some-of-the-best-food-nyc-has-to-offer/2601902/"
            title="ABC 7"
            date="Nov 8, 2017"
            description="NYC dad combines love for his kids, great food into one of the cutest Instagram accounts"
            imagePath="http://foodbabyny.com/press/press_20171108_abc7.jpg"
          ></InfoTile>
          <InfoTile href="https://www.timeout.com/new-york-kids/blog/10-amazing-mom-and-dad-instagrammers-to-follow-in-2017-101317"
            title="TimeOut New York"
            date="Oct 13, 2017"
            description="10 amazing Mom and Dad Instagrammers to follow in 2017"
            imagePath="http://foodbabyny.com/press/press_20171013_timeout.jpg"
          ></InfoTile>
          <InfoTile href="http://www.news12.com/story/36563064/food-photo-faceoff-umbertos-pizzeria-specialty-slices"
            title="News 12 LI"
            date="Oct 11, 2017"
            description="Food Photo Faceoff: Umberto's Pizzeria specialty slices"
            imagePath="http://foodbabyny.com/press/press_20171011_news12li.jpg"
          ></InfoTile>
          <InfoTile href="https://www.digitaltrends.com/photography/best-instagram-accounts/#/1-2"
            title="Digital Trends"
            date="Oct 9, 2017"
            description="Waste your time like you mean it by following the best Instagram accounts"
            imagePath="http://foodbabyny.com/press/press_20171009_digitaltrends.jpg"
          ></InfoTile>
          <InfoTile href="http://www.amny.com/lifestyle/back-to-school-faves-from-food-baby-ny-mama-glow-and-school-of-rock-star-1.14086372"
            title="AM New York"
            date="Aug 25, 2017"
            description="Back-to-school faves from Food Baby NY"
            imagePath="http://foodbabyny.com/press/press_20170825_amny.jpg"
          ></InfoTile>
          <InfoTile href="http://www.bravotv.com/blogs/foodbabyny-instagram-mike-chau"
            title="Bravo TV"
            date="Aug 7, 2017"
            description="This Dad’s Popular Instagram of His Kids Posing With Food Is the Cutest Thing You'll See All Day"
            imagePath="http://foodbabyny.com/press/press_20170807_bravotv.jpg"
          ></InfoTile>
          <InfoTile href="https://www.youtube.com/watch?v=GRCrXOxQlYU"
            title="Krylon"
            date="Jul 27, 2017"
            description="Krylon® | Add Your Flavor"
            imagePath="http://foodbabyny.com/press/press_20170727_krylon.jpg"
          ></InfoTile>
          <InfoTile href="https://www.facebook.com/NowThisNews/videos/1496043913819061/"
            title="NowThis"
            date="Jun 30, 2017"
            description="This dad became Instagram famous for combining food pics and baby pics"
            imagePath="http://foodbabyny.com/press/press_20170630_nowthis.jpg"
          ></InfoTile>
          <InfoTile href="https://www.youtube.com/watch?v=tCK7-US5qCI"
            title="Refinery29"
            date="Jun 26, 2017"
            description="Lucie Fink Spends Time With Food Instagrammers @FoodBabyNY"
            imagePath="http://foodbabyny.com/press/press_20170626_luciefink.jpg"
          ></InfoTile>
          <InfoTile href="http://blog.instagram.com/post/161973698242/170618-foodbabyny"
            title="Instagram"
            date="Jun 18, 2017"
            description="Cute Kids and Delicious Food: Meet the Dad Behind @foodbabyny"
            imagePath="http://foodbabyny.com/press/press_20170618_instagram.jpg"
          ></InfoTile>
        <InfoTile href="http://www.rd.com/food/fun/foodbaby-blogger/"
          title="Reader's Digest"
          date="May 3, 2017"
          description="You Need to Meet the 3-Year-Old Boy Taking Over the Food Blog World"
          imagePath="http://foodbabyny.com/press/press_20170503_readersdigest.jpg"
        ></InfoTile>
        <InfoTile href="http://ny.eater.com/2017/3/27/15068578/mike-chau-foodbabyny-restaurants"
          title="Eater"
          date="Mar 27, 2017"
          description="Meet the First Customers at Every New York Restaurant Opening"
          imagePath="http://foodbabyny.com/press/press_20170327_eater.jpg"
        ></InfoTile>
        <InfoTile href="https://www.thrillist.com/eat/nation/food-instagrammers-restaurant-industry-power-players"
          title="Thrillist"
          date="Feb 1, 2017"
          description="How Food Instagrammers Became The Restaurant Industry's New Power Players"
          imagePath="http://foodbabyny.com/press/press_20170201_thrillist.jpg"
        ></InfoTile>
        <InfoTile href="http://ediblequeens.ediblecommunities.com/eat/heres-where-most-popular-kids-queens-eat"
          title="Edible Queens"
          date="Jan 27, 2017"
          description="Here's Where the Most Popular Kids in Queens Eat"
          imagePath="http://foodbabyny.com/press/press_20170127_ediblequeens.jpg"
        ></InfoTile>
        <InfoTile href="http://www.amny.com/eat-and-drink/food-baby-ny-s-top-chinese-restaurants-shanghai-cafe-han-dynasty-more-1.12940256"
          title="AM New York"
          date="Jan 12, 2017"
          description="Food Baby NY’s top Chinese restaurants"
          imagePath="http://foodbabyny.com/press/press_20170112_amny.jpg"
        ></InfoTile>
        <InfoTile href="https://munchies.vice.com/en/articles/meet-the-nicest-man-on-yelp"
          title="Munchies"
          date="Jan 11, 2017"
          description="Meet the Nicest Man on Yelp"
          imagePath="http://foodbabyny.com/press/press_20170111_munchies.jpg"
        ></InfoTile>
        <InfoTile href="http://www.thisisinsider.com/best-food-instagram-2016-12?op=1"
          title="Insider"
          date="Dec 26, 2016"
          description="The 50 best food bloggers to follow on Instagram in 2017"
          imagePath="http://foodbabyny.com/press/press_20161226_insider.jpg"
        ></InfoTile>
        <InfoTile href="https://www.theodysseyonline.com/11-food-porn-instagram-accounts"
          title="Odyssey Online"
          date="Dec 5, 2016"
          description="11 Best Food Porn Instagram Accounts"
          imagePath="http://foodbabyny.com/press/press_20161205_odyssey.jpg"
        ></InfoTile>
        <InfoTile href="https://www.facebook.com/news.ebc/videos/1304195292948892/"
          title="EBC News"
          date="Nov 29, 2016"
          description="爆漿太犯規！療癒系炸彈漢堡 海量奶汁急速噴發"
          imagePath="http://foodbabyny.com/press/press_20161129_ebc.jpg"
        ></InfoTile>
        <InfoTile href="http://www.refinery29.com/2016/10/126433/inspirational-instagram-accounts-to-follow#slide"
          title="Refinery 29"
          date="Oct 21, 2016"
          description="30 Instagram Accounts That Will Make Your Life Better"
          imagePath="http://foodbabyny.com/press/press_20161021_refinery29.jpg"
        ></InfoTile>
        <InfoTile href="http://food-hacks.wonderhowto.com/news/instagramer-foodbabyny-turned-food-obsession-and-new-baby-into-fancy-free-meals-0174140/"
          title="Food Hacks Daily"
          date="Oct 13, 2016"
          description="How Instagramer @Foodbabyny Turned a Food Obsession and a New Baby into Fancy Free Meals"
          imagePath="http://foodbabyny.com/press/press_20161013_foodhacks.jpg"
        ></InfoTile>
        <InfoTile href="http://www.lifedaily.com/dad-photographs-his-kids-with-food-and-the-result-is-adorably-delicious/"
          title="Life Daily"
          date="Aug 16, 2016"
          description="Dad Photographs His Kids With Food And The Result Is Adorably Delicious"
          imagePath="http://foodbabyny.com/press/press_20160816_lifedaily.jpg"
        ></InfoTile>
        <InfoTile href="http://www.alleywatch.com/2016/07/can-learn-brainfood-2016/"
          title="Spoon University"
          date="Jul 25, 2016"
          description="What You Can Learn from Brainfood 2016"
          imagePath="http://foodbabyny.com/press/press_20160725_spoonu.jpg"
        ></InfoTile>
        <InfoTile href="http://observer.com/2016/07/these-instagram-famous-babies-try-every-new-restaurant-before-you-do/"
          title="Observer"
          date="Jul 22, 2016"
          description="These Instagram Famous Babies Try Every New Restaurant Before You Do"
          imagePath="http://foodbabyny.com/press/press_20160722_observer.jpg"
        ></InfoTile>
        <InfoTile href="http://www.thisisinsider.com/how-to-get-more-instagram-followers-2016-6"
          title="Insider"
          date="Jun 13, 2016"
          description="Two Instagram food stars with over 314,000 followers between them reveal how to get more followers"
          imagePath="http://foodbabyny.com/press/press_20160613_insider.jpg"
        ></InfoTile>
        <InfoTile href="http://www.kidsstoppress.com/2016/06/6-dads-on-instagram-who-are-slaying-this-being-a-dad-thing-follow-them-now/"
          title="Kids Stop Press"
          date="June 12, 2016"
          description="6 Dads On Instagram Who Are Slaying This Being A Dad Thing! Follow Them Now!"
          imagePath="http://foodbabyny.com/press/press_20160612_kidsstoppress.jpg"
        ></InfoTile>
        <InfoTile href="http://thechive.com/2016/05/17/food-baby-is-the-instagram-critic-the-people-deserve-25-photos/"
          title="The Chive"
          date="May 17, 2016"
          description="Food baby is the Instagram critic the people deserve"
          imagePath="http://foodbabyny.com/press/press_20160517_thechive.jpg"
        ></InfoTile>
        <InfoTile href="https://www.nytimes.com/2016/05/17/nyregion/new-york-today-toasting-a-tram-roosevelt-island-tramway-40-anniversary-instagram-accounts.html?_r=0"
          title="NY Times"
          date="May 17, 2016"
          description="Some of our favorite New York City Instagram accounts"
          imagePath="http://foodbabyny.com/press/press_20160517_nytimes.jpg"
        ></InfoTile>
        <InfoTile href="http://www.littlethings.com/cute-and-delicious-food-baby-nyc/"
          title="Little Things"
          date="May 16, 2016"
          description="Meet The Tiny Instagram Star With Over 100,000 Foodie Followers"
          imagePath="http://foodbabyny.com/press/press_20160516_littlethings.jpg"
        ></InfoTile>
        <InfoTile href="http://spoonuniversity.com/lifestyle/what-its-like-to-be-foodbabynys-dad"
          title="Spoon University"
          date="Apr 26, 2016"
          description="What It’s Actually Like to Be @foodbabyny’s Dad"
          imagePath="http://foodbabyny.com/press/press_20160426_spoonu.jpg"
        ></InfoTile>
        <InfoTile href="http://www.amny.com/lifestyle/nyc-instagram-accounts-to-follow-foodbabyny-humansofny-more-1.11725817"
          title="AM New York"
          date="Apr 25, 2016"
          description="NYC Instagram accounts to follow: @foodbabyny, @humansofny, more"
          imagePath="http://foodbabyny.com/press/press_20160425_amny.jpg"
        ></InfoTile>
        <InfoTile href="https://www.youtube.com/watch?v=iqRaXICOO8A&feature=youtu.be"
          title="The Chew"
          date="Mar 16, 2016"
          description="Carla Hall & Mario Batali discuss @foodbabyny"
          imagePath="http://foodbabyny.com/press/press_20160316_chew.jpg"
        ></InfoTile>
        <InfoTile href="https://www.yahoo.com/news/best-food-instagram-accounts-based-202538616.html?ref=gs"
          title="Yahoo! News"
          date="Feb 29, 2016"
          description="The Best Food Instagram Accounts to Follow, Based on Your Cravings"
          imagePath="http://foodbabyny.com/press/press_20160229_yahoo.jpg"
        ></InfoTile>
        <InfoTile href="https://www.facebook.com/SpoonUniversity/videos/1247844751911093/"
          title="Food Network Snapchat"
          date="Feb 13, 2016"
          description="Instagram star, FoodBabyNY, wants to give you some love advice."
          imagePath="http://foodbabyny.com/press/press_20160213_foodnetwork.jpg"
        ></InfoTile>
        <InfoTile href="http://travelsavvy.tv/destinations/new-york-city/restaurants/food-baby-nys-favorite-donut-shops/"
          title="Travel Savvy TV"
          date="Feb 2, 2016"
          description="Food Baby NY's Favorite Donut Shops"
          imagePath="http://foodbabyny.com/press/press_20160202_travelsavvy.jpg"
        ></InfoTile>
        <InfoTile href="http://www.delish.com/food-news/a45626/new-insta-obsession-food-baby-ny/"
          title="Delish"
          date="Jan 19, 2016"
          description="This Is Officially The Cutest Instagram Account Of All Time"
          imagePath="http://foodbabyny.com/press/press_20160119_delish.jpg"
        ></InfoTile>
        <InfoTile href="http://www.foodbeast.com/news/2015-top-foodbeasts/"
          title="Food Beast"
          date="Dec 31, 2015"
          description="2015's Best Instagram Food Porn Creators And Curators"
          imagePath="http://foodbabyny.com/press/press_20151231_foodbeast.jpg"
        ></InfoTile>
        <InfoTile href="https://www.timeout.com/newyork/blog/10-food-loving-instagram-accounts-to-follow-in-nyc-121715"
          title="TimeOut New York"
          date="Dec 17, 2015"
          description="10 food-loving Instagram accounts to follow in NYC"
          imagePath="http://foodbabyny.com/press/press_20151217_timeout.jpg"
        ></InfoTile>
        <InfoTile href="https://www.zagat.com/b/top-10-social-media-food-moments-of-2015"
          title="Zagat"
          date="Dec 10, 2015"
          description="Top 10 Social Media Food Moments of 2015"
          imagePath="http://foodbabyny.com/press/press_20151210_zagat.jpg"
        ></InfoTile>
        <InfoTile href="http://spoilednyc.com/2015/10/23/7-nyc-instagram-foodie-delicious-accounts/"
          title="Spoiled NYC"
          date="Oct 23, 2015"
          description="#FoodPorn Strong: 7 Amazing NYC Foodie Instagram Accounts That’ll Have You Drooling"
          imagePath="http://foodbabyny.com/press/press_20151023_spoiled.jpg"
        ></InfoTile>
        <InfoTile href="http://tapasmagazine.com/say-goodbye-to-cat-videos-the-foodie-baby-is-the-new-trend/"
          title="Tapas Magazine"
          date="Sep 1, 2015"
          description="Say Goodbye to Cat Videos, the Foodie Baby is the New Trend"
          imagePath="http://foodbabyny.com/press/press_20150901_tapas.jpg"
        ></InfoTile>
        <InfoTile href="http://www.lamag.com/digestblog/10-must-try-l-a-restaurants-according-to-instagrams-most-adorable-foodie/"
          title="LA Mag"
          date="Aug 3, 2015"
          description="10 Must-Try L.A. Restaurants According to Instagram’s Most Adorable Foodie"
          imagePath="http://foodbabyny.com/press/press_20150803_lamag.jpg"
        ></InfoTile>
        <InfoTile href="http://www.amny.com/eat-and-drink/nyc-food-instagrammers-you-should-be-following-1.10680577"
          title="AM New York"
          date="Jul 27, 2015"
          description="NYC food Instagrammers you need to follow immediately"
          imagePath="http://foodbabyny.com/press/press_20150727_amny.jpg"
        ></InfoTile>
        <InfoTile href="http://www.thedailymeal.com/news/eat/internet-famous-toddler-eating-his-way-around-trendiest-new-york-restaurants-free/072115"
          title="The Daily Meal"
          date="Jul 21, 2015"
          description="This Internet-Famous Toddler Is Eating His Way Around the Trendiest New York Restaurants for Free"
          imagePath="http://foodbabyny.com/press/press_20150721_dailymeal.jpg"
        ></InfoTile>
        <InfoTile href="http://greatideas.people.com/2015/07/20/toddler-foodbabyny-instagram-food-restaurants/"
          title="People Magazine"
          date="Jul 20, 2015"
          description="This Toddler Is Eating His Way Through New York’s Restaurant Scene — for Free"
          imagePath="http://foodbabyny.com/press/press_20150720_people.jpg"
        ></InfoTile>
        <InfoTile href="http://www.thegreatdaily.com/cat43/node460767"
          title="GreatDaily"
          date="Jul 20, 2015"
          description="全紐約最吃得開的小孩！2歲小吃貨爆紅上餐廳不用錢"
          imagePath="http://foodbabyny.com/press/press_20150720_greatdaily.jpg"
        ></InfoTile>
        <InfoTile href="http://www.foodandwine.com/fwx/food/toddler-eats-free-all-over-new-york?xid=soc_socialflow_facebook_fw"
          title="Food & Wine"
          date="Jul 16, 2015"
          description="This Toddler Eats For Free All Over New York"
          imagePath="http://foodbabyny.com/press/press_20150716_foodandwine.jpg"
        ></InfoTile>
        <InfoTile href="http://www.nydailynews.com/life-style/eats/eats-beat-aziz-ansari-dates-nas-chicken-article-1.2285884"
          title="NY Daily News"
          date="Jul 8, 2015"
          description="Matthew (Food Baby) Chau works a white chef’s hat as Tom Collicchio"
          imagePath="http://foodbabyny.com/press/press_20150708_dailynews.jpg"
        ></InfoTile>
        <InfoTile href="http://aplus.com/a/foodbabyny-has-delicious-food-and-adorable-kids?so=rmHNcw58UHMVx9mVV946JQ&ref=ns"
          title="A Plus"
          date="Jun 29, 2015"
          description="FoodBabyNY Is About Family And, Of Course, Delicious Food"
          imagePath="http://foodbabyny.com/press/press_20150629_aplus.jpg"
        ></InfoTile>
        <InfoTile href="https://www.zagat.com/v/new-york-city/a-day-in-the-life-two-year-old-instagram-sensation-foodbabyny"
          title="Zagat"
          date="Jun 25, 2015"
          description="A Day in the Life: Two-Year-Old Instagram Sensation @FoodBabyNY"
          imagePath="http://foodbabyny.com/press/press_20150625_zagat.jpg"
        ></InfoTile>
        <InfoTile href="http://www.businessinsider.com/2-year-old-matthew-chau-is-a-yelp-celebrity-2015-6"
          title="Business Insider"
          date="Jun 23, 2015"
          description="This 2-year-old became a Yelp celebrity, and now his family eats all over NYC for free"
          imagePath="http://foodbabyny.com/press/press_20150623_businessinsider.jpg"
        ></InfoTile>
        <InfoTile href="http://www.cosmopolitan.com/food-cocktails/a42238/foodbaby-is-living-the-dream/"
          title="Cosmopolitan"
          date="Jun 22, 2015"
          description="What It's Really Like to Be a Yelp Celebrity When You're Not Even 2 Years Old"
          imagePath="http://foodbabyny.com/press/press_20150622_cosmo.jpg"
        ></InfoTile>
        <InfoTile href="http://blog.opentable.com/2015/five-foodie-fathers-to-follow-on-instagram-for-fathersday/"
          title="OpenTable"
          date="Jun 16, 2015"
          description="Five Foodie Fathers to Follow on Instagram for #FathersDay"
          imagePath="http://foodbabyny.com/press/press_20150616_opentable.jpg"
        ></InfoTile>
        <InfoTile href="http://www.dailymail.co.uk/femail/article-3107722/Mouth-watering-Instagram-account-gives-new-meaning-term-food-baby-sweet-savory-pictures-toddler-posing-delicious-dishes.html"
          title="Daily Mail"
          date="Jun 2, 2015"
          description="Mouth-watering Instagram account gives new meaning to the term 'food baby'"
          imagePath="http://foodbabyny.com/press/press_20150602_dailymail.jpg"
        ></InfoTile>
        <InfoTile href="http://www.foodbeast.com/news/foodbabyny/"
          title="Food Beast"
          date="May 6, 2015"
          description="Lunch With @FoodBabyNY, The Cutest Most Popular Foodie On Instagram"
          imagePath="http://foodbabyny.com/press/press_20150506_foodbeast.jpg"
        ></InfoTile>
        <InfoTile href="http://spoonuniversity.com/lifestyle/10-reasons-following-foodbabyny-instagram"
          title="Spoon University"
          date="Apr 24, 2015"
          description="10 Reasons Why You Should Be Following @foodbabyny on Instagram"
          imagePath="http://foodbabyny.com/press/press_20150424_spoonu.jpg"
        ></InfoTile>
        <InfoTile href="http://www.manrepeller.com/best_of_internet/food-instagrams-to-follow.html"
          title="Man Repeller"
          date="Apr 21, 2015"
          description="The Only Food-stagram to Follow"
          imagePath="http://foodbabyny.com/press/press_20150421_manrepeller.jpg"
        ></InfoTile>
        <InfoTile href="http://www.hlntv.com/shows/the-daily-share/articles/2015/03/31/meet-nyc-s-newest-food-critic-food-baby-ny/"
          title="HLN TV"
          date="April 1, 2015"
          description="Meet NYC’s newest food critic: Food Baby NY"
          imagePath="http://foodbabyny.com/press/press_20150401_hlntv.jpg"
        ></InfoTile>
        <InfoTile href="http://www.nydailynews.com/life-style/eats/foodbabyny-instagram-account-boasts-pint-sized-food-critic-article-1.2163653"
          title="NY Daily News"
          date="Mar 26, 2015"
          description="FoodBabyNY Instagram account boasts pint-sized food critic"
          imagePath="http://foodbabyny.com/press/press_20150326_dailynews.jpg"
        ></InfoTile>
        <InfoTile href="http://spoilednyc.com/2015/03/18/10-instagrams-thatll-make-you-fall-in-love-with-nyc/"
          title="Spoiled NYC"
          date="Mar 18, 2015"
          description="10 Instagrams That’ll Make You Fall in Love With NYC All Over Again"
          imagePath="http://foodbabyny.com/press/press_20150318_spoiled.jpg"
        ></InfoTile>
        <InfoTile href="http://www.lacucinaitaliana.it/news/trend/donuts-e-ciambelle-no-food-baby-ny-adora-pasta-e-gelato/"
          title="La Cucina Italiana"
          date="Mar 8, 2015"
          description="Donuts e ciambelle? No, Food Baby NY adora pasta e gelato"
          imagePath="http://foodbabyny.com/press/press_20150308_lacucina.jpg"
        ></InfoTile>
        <InfoTile href="https://www.youtube.com/watch?v=KCMBgl6HoX8&feature=youtu.be"
          title="Fox 5 News"
          date="Mar 6, 2015"
          description="TimeOut New York's Top 10 NY Instagram accounts"
          imagePath="http://foodbabyny.com/press/press_20150306_fox5.jpg"
        ></InfoTile>
        <InfoTile href="https://www.timeout.com/newyork/blog/these-are-the-nyc-instagram-accounts-you-absolutely-need-to-be-following-right-now"
          title="TimeOut New York"
          date="Mar 3, 2015"
          description="These are the NYC Instagram accounts you absolutely need to be following right now"
          imagePath="http://foodbabyny.com/press/press_20150303_timeout.jpg"
        ></InfoTile>
        <InfoTile href="http://www.eater.com/2015/2/18/8064877/Food-Baby-NY"
          title="Eater"
          date="Feb 18, 2015"
          description="Stop Whatever You're Doing and Follow Food Baby NY on Instagram"
          imagePath="http://foodbabyny.com/press/press_20150218_eater.jpg"
        ></InfoTile>
        <InfoTile href="https://www.thrillist.com/eat/nation/best-food-instagrams-best-food-photography"
          title="Thrillist"
          date="Jan 22, 2015"
          description="The 20 Best Food Instagrammers In The Country"
          imagePath="http://foodbabyny.com/press/press_20150122_thrillist.jpg"
        ></InfoTile>
        <InfoTile href="http://www.amny.com/eat-and-drink/food-baby-ny-eats-better-than-you-do-1.9649309"
          title="AM New York"
          date="Nov 24, 2014"
          description="This baby New Yorker eats better than you do"
          imagePath="http://foodbabyny.com/press/press_20141124_amny.jpg"
        ></InfoTile>
        <InfoTile href="https://www.thrillist.com/entertainment/new-york/best-nyc-instagrams"
          title="Thrillist"
          date="Nov 9, 2014"
          description="24 NYC Instagrams You Need To Follow Right Now"
          imagePath="http://foodbabyny.com/press/press_20141109_thrillist.jpg"
        ></InfoTile>
        <InfoTile href="http://www.today.com/health/cute-delicious-foodbabyny-instagram-combines-love-food-son-1D80239687"
          title="The Today Show"
          date="Oct 24, 2014"
          description="Cute and delicious: ‘FoodbabyNY’ Instagram combines love of food and son"
          imagePath="http://foodbabyny.com/press/press_20141024_today.jpg"
        ></InfoTile>
        <InfoTile href="http://www.huffingtonpost.com/2014/10/22/food-baby-ny_n_6023818.html?utm_hp_ref=email_share"
          title="The Huffington Post"
          date="Oct 22, 2014"
          description="‘Food Baby NY’ Instagram Account Is The Perfect Combination Of Cute And Delicious"
          imagePath="http://foodbabyny.com/press/press_20141022_huffpost.jpg"
        ></InfoTile>
        <InfoTile href="http://redtri.com/this-instagram-is-your-baby-and-foodie-connisseur/?utm_source=FB&utm_medium=NATL&utm_campaign=FB-NATL"
          title="Red Tricycle"
          date="Oct 3, 2014"
          description="This Instagram is Your Baby and Foodie Connoisseur"
          imagePath="http://foodbabyny.com/press/press_20141003_redtri.jpg"
        ></InfoTile>
        <InfoTile href="http://www.msn.com/en-us/video/viral/adorable-instagram-account-spotlights-baby-and-fancy-food/vi-BB75IeU"
          title="MSN Viral Video"
          date="Oct 3, 2014"
          description="Adorable Instagram Account Spotlights Baby and Fancy Food"
          imagePath="http://foodbabyny.com/press/press_20141003_msn.jpg"
        ></InfoTile>
        <InfoTile href="http://www.refinery29.com/food-baby-ny-instagram"
          title="Refinery 29"
          date="Oct 2, 2014"
          description="Food Baby Is Our Latest Instagram Obsession"
          imagePath="http://foodbabyny.com/press/press_20141002_refinery29.jpg"
        ></InfoTile>
        <InfoTile href="http://quefood.com/theres-no-better-combo-than-delicious-food-and-an-adorable-baby-photos/"
          title="Elite Daily"
          date="Oct 1, 2014"
          description="There’s No Better Combo Than Delicious Food And An Adorable Baby"
          imagePath="http://foodbabyny.com/press/press_20141001_elitedaily.jpg"
        ></InfoTile>
        <InfoTile href="http://firstwefeast.com/eat/2014/09/foodbabyny-is-our-new-instagram-obsession"
          title="First We Feast"
          date="Sep 29, 2014"
          description="Meet Our New Instagram Obsession: @FoodBabyNY"
          imagePath="http://foodbabyny.com/press/press_20140929_fwf.jpg"
        ></InfoTile>
      </div>
    );
  }
}

export default Press;



// WEBPACK FOOTER //
// ./src/js/Press.js